import { t } from "../i18n/translations";
import { formatDate } from "../utils/dateUtils";
import { initialLetter } from "../utils/idUtils";

export default function SharedModeScreen({
  sharedLang,
  sharedMember,
  sharedWishlist,
  user,
  generatingPDF,
  toast,
  generatePDF,
  setSharedMode,
  setCameFromShared,
  setScreen,
  togglePurchased,
}) {
  const sl = sharedLang;
  const str = (key) => t(sl, key);
  const m = sharedMember;
  const w = sharedWishlist;

  if (!m) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", color: "#999" }}>
        {str("listNotFound")}
      </div>
    );
  }

  const color = m.color || "#9b59b6";
  const gifts = w?.gifts || [];

  return (
    <>
      <div className="app-shell">
        <header className="header">
  <div className="header-titulo no-click" style={{ cursor: "pointer" }} onClick={() => { window.location.hash = ""; window.location.reload(); }}>
    ✦ Wishlu
  </div>
  <div style={{ display: "flex", gap: 4 }}>
    <button style={{ background: sl === "en" ? "#d4a853" : "transparent", border: "1px solid #555", borderRadius: 8, padding: "4px 8px", cursor: "pointer", fontSize: 18, lineHeight: 1 }}
      onClick={() => { window.location.hash = window.location.hash.replace(/\/(en|es|fi)\//, "/en/"); window.location.reload(); }}>🇬🇧</button>
    <button style={{ background: sl === "es" ? "#d4a853" : "transparent", border: "1px solid #555", borderRadius: 8, padding: "4px 8px", cursor: "pointer", fontSize: 18, lineHeight: 1 }}
      onClick={() => { window.location.hash = window.location.hash.replace(/\/(en|es|fi)\//, "/es/"); window.location.reload(); }}>🇲🇽</button>
    <button style={{ background: sl === "fi" ? "#d4a853" : "transparent", border: "1px solid #555", borderRadius: 8, padding: "4px 8px", cursor: "pointer", fontSize: 18, lineHeight: 1 }}
      onClick={() => { window.location.hash = window.location.hash.replace(/\/(en|es|fi)\//, "/fi/"); window.location.reload(); }}>🇫🇮</button>
  </div>
</header>

        <div className="pantalla">
          <div className="contenido">
            <div className="perfil-header">
              <div className="perfil-avatar" style={{ background: color, boxShadow: "0 0 0 4px " + color + "33" }}>
                {initialLetter(m.name)}
              </div>
              <div className="perfil-info">
                <h2>{m.name}</h2>
                <p>
                  {gifts.length} {str("onTheirList")}
                  {m.birthday && " · 🎂 " + formatDate(m.birthday)}
                </p>
              </div>
            </div>

            

            {gifts.length === 0 ? (
              <div className="vacio">
                <div className="vacio-icono">🎁</div>
                <h3>{str("emptyList")}</h3>
                <p>{str("noGifts")}</p>
              </div>
            ) : (
              <>
                {/* Regalos CON foto — grid */}
                {gifts.some(g => g.photoUrl) && (
                  <div className="grilla">
                    {gifts.filter(g => g.photoUrl).map((g) => {
                      const isOwner = user && user.uid === m.id;
                      const showPurchased = g.purchased && !isOwner;
                      const canUnmark = g.purchased && user && g.purchasedBy === user.uid;
                      return (
                        <div key={g.id} className={"tarjeta" + (showPurchased ? " comprado" : "")}>
                          <div className="tarjeta-img-wrap" ref={(el) => { if (el) { const img = el.querySelector("img"); if (img && img.complete) el.classList.add("tarjeta-img-loaded"); } }}>
                            <div className="tarjeta-img-spinner">🌙</div>
                            <img src={g.photoUrl} alt={g.name || "Gift"} className="tarjeta-img" loading="lazy" style={{ width: "100%", borderRadius: "14px 14px 0 0" }} onLoad={(e) => e.target.parentNode.classList.add("tarjeta-img-loaded")} />
                          </div>
                          <div className="tarjeta-cuerpo">
                            {g.name && <div className="tarjeta-nombre">{g.name}</div>}
                            {g.description && <div className="tarjeta-desc">{g.description}</div>}
                            {showPurchased && <span className="comprado-badge">{str("alreadyPurchased")}</span>}
                            {!showPurchased && g.link && <a href={g.link} target="_blank" rel="noopener noreferrer" className="tarjeta-link">{str("viewProduct")}</a>}
                            {!isOwner && (
                              <div className="tarjeta-acciones">
                                {!user ? (
                                  <button className="btn btn-gris btn-sm" onClick={() => { setSharedMode(false); setCameFromShared(true); setScreen("login"); }}>{str("signInToBuy")}</button>
                                ) : !g.purchased ? (
                                  <button className="btn btn-negro btn-sm" onClick={() => togglePurchased(w.id, g.id, g, true)}>{str("illBuyThis")}</button>
                                ) : canUnmark ? (
                                  <button className="btn btn-gris btn-sm" onClick={() => togglePurchased(w.id, g.id, g, true)}>{str("unmark")}</button>
                                ) : null}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Regalos SIN foto — tarjeta "siempre viene bien" */}
                {gifts.some(g => !g.photoUrl) && (
                  <div style={{ background: "#ffffff", border: "1px solid #2e2e2e", borderRadius: 14, overflow: "hidden", marginTop: 16 }}>
                    <div style={{ background: "#d4a853", padding: "10px 14px", display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ fontSize: 15 }}>🎁</span>
                      <span style={{ fontSize: 12, fontWeight: 600, color: "#4a2e00" }}>
                        {sl === "es" ? "siempre viene bien:" : sl === "fi" ? "sopii aina:" : "always a good gift:"}
                      </span>
                    </div>
                    <div style={{ padding: "8px 14px 12px" }}>
                     {gifts.filter(g => !g.photoUrl && !g.price && !g.link).map((g, i, arr) => {
  return (
    <div key={g.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 0", borderBottom: i < arr.length - 1 ? "0.5px solid #2e2e2e" : "none" }}>
      <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#d4a853", flexShrink: 0 }} />
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13, color: "#1a1a1a" }}>
  {g.name}
  {g.description && (
    <span style={{ fontSize: 11, color: "#aaa", marginLeft: 4 }}>({g.description})</span>
  )}
</div>
      </div>
    </div>
  );
})}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      
      {!user && (
  <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, display: "flex", alignItems: "center", gap: 12, background: "linear-gradient(135deg, #1a1a1a, #2a2a2a)", padding: "14px 16px", zIndex: 50 }}>
    <span style={{ fontSize: 26, flexShrink: 0 }}>🎁</span>
    <div style={{ flex: 1 }}>
      <div style={{ color: "#f5f0e8", fontSize: 13, lineHeight: 1.4 }}>
        {sl === "es" ? "Inicia sesión para reservar regalos o crea tu propia Wishlu" : sl === "fi" ? "Kirjaudu varataksesi lahjoja tai luo oma Wishlu" : "Sign in to reserve gifts or create your own Wishlu"}
      </div>
    </div>
    <div style={{ display: "flex", flexDirection: "column", gap: 6, flexShrink: 0 }}>
      <button className="btn btn-dorado btn-sm" onClick={() => { setCameFromShared(true); setSharedMode(false); setScreen("register"); }}>{str("signUp")}</button>
      <button className="btn btn-gris btn-sm" onClick={() => { setCameFromShared(true); setSharedMode(false); setScreen("login"); }}>{str("signIn")}</button>
    </div>
  </div>
)}
      {toast && <div className="toast">{toast}</div>}
    </>
  );
}